/* __next_internal_client_entry_do_not_use__ SDUIGridAutoColumnLayoutBase auto */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { getSlateSpacingPixels } from "@faire/retailer-shared/SlateMappings/getSlateSpacingPixels";
import { SDUIOnClickHandler } from "@faire/retailer-visitor-shared/components/SDUI/__internal__/SDUIOnClickHandler/SDUIOnClickHandler";
import { ActionLoggingEventParams } from "@faire/retailer-visitor-shared/components/SDUI/__internal__/types";
import { getSlateButtonVariant } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Button/getSlateButtonVariant";
import { SDUIGridHeaderRow } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Grid/__internal__/SDUIGridHeaderRow";
import { SDUIGridRow } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Grid/__internal__/SDUIGridRow";
import * as gridStyles from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Grid/__internal__/styles.css";
import { AUTO_COLUMN_LAYOUT_GRID_MAX_TILES_PER_ROW, autoGridStyles } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Grid/__internal__/utils/gridStylingUtils";
import { useCurrentTruncationBehaviour } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Grid/__internal__/utils/useGetCurrentTruncationBehaviour";
import { useResponsiveTileWidth } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Grid/__internal__/utils/useResponsiveTileWidth";
import { Button } from "@faire/web--source/slate/Button";
import { Arrow } from "@faire/web--source/slate/icons/foundation/Arrow";
import { Column } from "@faire/web--source/slate/Layout";
import { useResponsiveValue } from "@faire/web--source/ui/hooks/useResponsiveValue";
import { useViewportWidth } from "@faire/web--source/ui/hooks/useViewportWidth";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { IButtonElement } from "@faire/web-api--source/indigofair/data/IButtonElement";
import { IGridComponent } from "@faire/web-api--source/indigofair/data/IGridComponent";
import { IGridStyle } from "@faire/web-api--source/indigofair/data/IGridStyle";
import { IImageTile } from "@faire/web-api--source/indigofair/data/IImageTile";
import { Spacing } from "@faire/web-api--source/indigofair/data/Spacing";
// eslint-disable-next-line no-restricted-imports
import { assignInlineVars } from "@vanilla-extract/dynamic";
import classNames from "classnames";
import chunk from "lodash/chunk";
import React, { useEffect, useMemo, useRef, useState } from "react";
export var SDUIGridAutoColumnLayoutBase = function(param) {
    var gridComponent = param.gridComponent, loggingData = param.loggingData;
    var _truncationBehaviour_clipTrunctation, _truncationBehaviour_expandTruncation, _truncationBehaviour_clipTrunctation1, _truncationBehaviour_expandTruncation1;
    var log_tile_batch_view = gridComponent.log_tile_batch_view, responsive_truncation_behaviour = gridComponent.responsive_truncation_behaviour, _gridComponent_style = gridComponent.style, style = _gridComponent_style === void 0 ? IGridStyle.build() : _gridComponent_style, title = gridComponent.title, responsive_title = gridComponent.responsive_title, header_background_icon = gridComponent.header_background_icon, responsive_header_background_icon = gridComponent.responsive_header_background_icon, tiles = gridComponent.tiles, _gridComponent_truncation_behaviour = gridComponent.truncation_behaviour, truncation_behaviour = _gridComponent_truncation_behaviour === void 0 ? IGridComponent.ITruncationBehaviour.build() : _gridComponent_truncation_behaviour;
    var column_spacing = style.column_spacing, row_spacing = style.row_spacing;
    var columnSpacingPixels = useMemo(function() {
        return getSlateSpacingPixels(column_spacing !== null && column_spacing !== void 0 ? column_spacing : Spacing.SPACING_NONE);
    }, [
        column_spacing
    ]);
    // TODO (FD-199432): This is an anti-pattern and we generally don't want components reaching into
    // their children's contents to retrive information. This information should be moved into the proto.
    var imageTileVariant = useMemo(function() {
        var _tiles_find_image_tile_style, _tiles_find_image_tile, _tiles_find;
        var _tiles_find_image_tile_style_variant;
        return (_tiles_find_image_tile_style_variant = (_tiles_find = tiles.find(function(tile) {
            var _tile_image_tile_style, _tile_image_tile;
            return (_tile_image_tile = tile.image_tile) === null || _tile_image_tile === void 0 ? void 0 : (_tile_image_tile_style = _tile_image_tile.style) === null || _tile_image_tile_style === void 0 ? void 0 : _tile_image_tile_style.variant;
        })) === null || _tiles_find === void 0 ? void 0 : (_tiles_find_image_tile = _tiles_find.image_tile) === null || _tiles_find_image_tile === void 0 ? void 0 : (_tiles_find_image_tile_style = _tiles_find_image_tile.style) === null || _tiles_find_image_tile_style === void 0 ? void 0 : _tiles_find_image_tile_style.variant) !== null && _tiles_find_image_tile_style_variant !== void 0 ? _tiles_find_image_tile_style_variant : IImageTile.ImageTileVariant.IMAGE_TILE_VARIANT_UNKNOWN;
    }, [
        tiles
    ]);
    var viewportWidth = useViewportWidth(function(width) {
        return width;
    });
    var containerRef = useRef(null);
    var truncationBehaviour = useCurrentTruncationBehaviour(truncation_behaviour, responsive_truncation_behaviour);
    var _truncationBehaviour_clipTrunctation_max_rows;
    var _useState = _sliced_to_array(useState(truncationBehaviour.noTruncation ? undefined : (_truncationBehaviour_clipTrunctation_max_rows = (_truncationBehaviour_clipTrunctation = truncationBehaviour.clipTrunctation) === null || _truncationBehaviour_clipTrunctation === void 0 ? void 0 : _truncationBehaviour_clipTrunctation.max_rows) !== null && _truncationBehaviour_clipTrunctation_max_rows !== void 0 ? _truncationBehaviour_clipTrunctation_max_rows : (_truncationBehaviour_expandTruncation = truncationBehaviour.expandTruncation) === null || _truncationBehaviour_expandTruncation === void 0 ? void 0 : _truncationBehaviour_expandTruncation.collapsed_max_rows), 2), currentNumberOfRows = _useState[0], setCurrentNumberOfRows = _useState[1];
    var _useState1 = _sliced_to_array(useState(undefined), 2), currentNumberOfTilesPerRow = _useState1[0], setCurrentNumberOfTilesPerRow = _useState1[1];
    var hasHiddenTiles = currentNumberOfRows !== undefined && currentNumberOfTilesPerRow !== undefined && tiles.length > currentNumberOfTilesPerRow * currentNumberOfRows;
    var expandButtonLoggingParams = useMemo(function() {
        return ActionLoggingEventParams.build(_object_spread_props(_object_spread({}, loggingData), {
            action_instance_identifier: "EXPAND"
        }));
    }, [
        loggingData
    ]);
    var tileChunks = useMemo(function() {
        return chunk(tiles, currentNumberOfTilesPerRow);
    }, [
        currentNumberOfTilesPerRow,
        tiles
    ]);
    useEffect(function() {
        var _truncationBehaviour_clipTrunctation, _truncationBehaviour_expandTruncation;
        var _truncationBehaviour_clipTrunctation_max_rows;
        setCurrentNumberOfRows(truncationBehaviour.noTruncation ? undefined : (_truncationBehaviour_clipTrunctation_max_rows = (_truncationBehaviour_clipTrunctation = truncationBehaviour.clipTrunctation) === null || _truncationBehaviour_clipTrunctation === void 0 ? void 0 : _truncationBehaviour_clipTrunctation.max_rows) !== null && _truncationBehaviour_clipTrunctation_max_rows !== void 0 ? _truncationBehaviour_clipTrunctation_max_rows : (_truncationBehaviour_expandTruncation = truncationBehaviour.expandTruncation) === null || _truncationBehaviour_expandTruncation === void 0 ? void 0 : _truncationBehaviour_expandTruncation.collapsed_max_rows);
    }, [
        truncationBehaviour.noTruncation,
        (_truncationBehaviour_clipTrunctation1 = truncationBehaviour.clipTrunctation) === null || _truncationBehaviour_clipTrunctation1 === void 0 ? void 0 : _truncationBehaviour_clipTrunctation1.max_rows,
        (_truncationBehaviour_expandTruncation1 = truncationBehaviour.expandTruncation) === null || _truncationBehaviour_expandTruncation1 === void 0 ? void 0 : _truncationBehaviour_expandTruncation1.collapsed_max_rows
    ]);
    var responsiveTileWidth = useResponsiveTileWidth(imageTileVariant);
    var tileWidth = useResponsiveValue(responsiveTileWidth);
    useEffect(function() {
        var _containerRef_current;
        var containerWidth = (_containerRef_current = containerRef.current) === null || _containerRef_current === void 0 ? void 0 : _containerRef_current.getBoundingClientRect().width;
        if (!containerWidth) {
            setCurrentNumberOfTilesPerRow(AUTO_COLUMN_LAYOUT_GRID_MAX_TILES_PER_ROW);
        } else if (containerWidth && tileWidth) {
            // the equation used to get the number of tiles that fit in the component here is
            // containerWidth = (tileWidth * numTiles) + [columnSpacingPixels * (numTiles - 1)]
            var tilesPerRow = Math.min(Math.floor((containerWidth + columnSpacingPixels) / (tileWidth + columnSpacingPixels)), AUTO_COLUMN_LAYOUT_GRID_MAX_TILES_PER_ROW);
            setCurrentNumberOfTilesPerRow(tilesPerRow);
        }
    }, [
        viewportWidth,
        imageTileVariant,
        columnSpacingPixels,
        tileWidth
    ]);
    return /*#__PURE__*/ _jsxs(Column, {
        className: gridStyles.SDUIGridWrapper,
        children: [
            /*#__PURE__*/ _jsx(SDUIGridHeaderRow, {
                title: title,
                responsiveTitle: responsive_title,
                backgroundIcon: header_background_icon,
                responsiveBackgroundIcon: responsive_header_background_icon,
                loggingData: loggingData
            }),
            tileChunks.map(function(tiles, index) {
                var _tiles__logging_data, _tiles_;
                if (currentNumberOfRows !== undefined && index >= currentNumberOfRows) {
                    return null;
                }
                var _tiles__logging_data_instance_identifier;
                return /*#__PURE__*/ _jsx(SDUIGridRow, {
                    tiles: tiles,
                    loggingData: loggingData,
                    className: classNames(gridStyles.gridTileContainer, gridStyles.autoColumnGridJustificationStyle, gridStyles.tabletAndAboveGridTemplateColumns, gridStyles.desktopAndAboveGridTemplateColumns),
                    componentStyle: assignInlineVars(autoGridStyles(index === 0 ? undefined : row_spacing, column_spacing, responsiveTileWidth)),
                    containerRef: index === 0 ? containerRef : undefined,
                    logTileBatchView: log_tile_batch_view
                }, (_tiles__logging_data_instance_identifier = (_tiles_ = tiles[0]) === null || _tiles_ === void 0 ? void 0 : (_tiles__logging_data = _tiles_.logging_data) === null || _tiles__logging_data === void 0 ? void 0 : _tiles__logging_data.instance_identifier) !== null && _tiles__logging_data_instance_identifier !== void 0 ? _tiles__logging_data_instance_identifier : index);
            }),
            truncationBehaviour.expandTruncation && hasHiddenTiles ? /*#__PURE__*/ _jsx(ShowMoreToggleButton, {
                variant: truncationBehaviour.expandTruncation.variant,
                numHiddenTiles: tiles.length - currentNumberOfTilesPerRow * currentNumberOfRows,
                onClick: function() {
                    return setCurrentNumberOfRows(undefined);
                },
                isGridExpanded: currentNumberOfRows === undefined,
                loggingEventParams: expandButtonLoggingParams,
                clickActions: truncationBehaviour.expandTruncation.on_click
            }) : null
        ]
    });
};
var ShowMoreToggleButton = function(param) {
    var isGridExpanded = param.isGridExpanded, _param_variant = param.variant, variant = _param_variant === void 0 ? IButtonElement.ButtonVariant.PRIMARY : _param_variant, numHiddenTiles = param.numHiddenTiles, onClick = param.onClick, loggingEventParams = param.loggingEventParams, _param_clickActions = param.clickActions, clickActions = _param_clickActions === void 0 ? [] : _param_clickActions;
    return /*#__PURE__*/ _jsx(SDUIOnClickHandler, {
        className: gridStyles.expandButtonRowStyle,
        onClickActions: clickActions,
        loggingData: loggingEventParams,
        children: /*#__PURE__*/ _jsx(Button, {
            variant: getSlateButtonVariant(variant),
            onClick: onClick,
            children: isGridExpanded ? null : /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(StrictLocalMsg, {
                        id: "4cwiCv",
                        defaultMessage: [
                            {
                                type: 6,
                                value: "tileNumber",
                                options: {
                                    one: {
                                        value: [
                                            {
                                                type: 0,
                                                value: "Show "
                                            },
                                            {
                                                type: 7
                                            },
                                            {
                                                type: 0,
                                                value: " more"
                                            }
                                        ]
                                    },
                                    other: {
                                        value: [
                                            {
                                                type: 0,
                                                value: "Show "
                                            },
                                            {
                                                type: 7
                                            },
                                            {
                                                type: 0,
                                                value: " more"
                                            }
                                        ]
                                    }
                                },
                                offset: 0,
                                pluralType: "cardinal"
                            }
                        ],
                        values: {
                            tileNumber: numHiddenTiles
                        }
                    }),
                    /*#__PURE__*/ _jsx(Arrow, {
                        direction: "down",
                        width: "16px",
                        height: "16px"
                    })
                ]
            })
        })
    });
};
